module.exports = __webpack_public_path__ + "img/ywc.0149260e.png";